/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Filter_FormulasInputs */

const en_gc_resources_filter_formulas = /** @type {(inputs: Gc_Resources_Filter_FormulasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulas`)
};

const zh_gc_resources_filter_formulas = /** @type {(inputs: Gc_Resources_Filter_FormulasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式`)
};

/**
* | output |
* | --- |
* | "Formulas" |
*
* @param {Gc_Resources_Filter_FormulasInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_filter_formulas = /** @type {((inputs?: Gc_Resources_Filter_FormulasInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Filter_FormulasInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_filter_formulas(inputs)
	return zh_gc_resources_filter_formulas(inputs)
});
export { gc_resources_filter_formulas as "gc.resources.filter.formulas" }